import { render } from "./BackButton.vue?vue&type=template&id=0234730a&scoped=true&ts=true"
import script from "./BackButton.vue?vue&type=script&lang=ts"
export * from "./BackButton.vue?vue&type=script&lang=ts"

import "./BackButton.vue?vue&type=style&index=0&id=0234730a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0234730a"]])

export default __exports__